// ExportToPDF.js
import React from "react";
import { Button } from "@mui/material";
import jsPDF from "jspdf";
import "jspdf-autotable";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const ExportToPDF = ({ data, columns, title }) => {
  const handleExport = () => {
    const doc = new jsPDF();

    // Add title
    doc.setFontSize(18);
    doc.text(title, 14, 22);

    // Prepare the table
    const tableColumn = columns.map((col) => col.label);
    const tableRows = data.map((row) =>
      columns.map((col) => {
        // Customize data extraction based on your data structure
        if (col.id === "procedure_date") {
          return new Date(row[col.id]).toLocaleDateString();
        }
        return row[col.id] ? row[col.id].toString() : "";
      }),
    );

    // Add autoTable
    doc.autoTable({
      startY: 30,
      head: [tableColumn],
      body: tableRows,
      theme: "striped",
      headStyles: { fillColor: [41, 128, 185] },
      styles: { fontSize: 10 },
    });

    // Save the PDF
    doc.save(`${title}.pdf`);
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      startIcon={<PictureAsPdfIcon />}
      onClick={handleExport}
      sx={{ marginBottom: 2 }}
    >
      Export to PDF
    </Button>
  );
};

export default ExportToPDF;
